import { render, staticRenderFns } from "./ExpertsSection.vue?vue&type=template&id=64b62bdc"
import script from "./ExpertsSection.vue?vue&type=script&lang=ts"
export * from "./ExpertsSection.vue?vue&type=script&lang=ts"
import style0 from "./ExpertsSection.vue?vue&type=style&index=0&id=64b62bdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports